import { View, Text, StyleSheet, ImageBackground, Button, TextInput } from 'react-native';
import { useState } from 'react';
import Footer from '../components/Footer';
import validator from 'validator';
import { ERROR_MESSAGES } from '../constants/errorMessages';
import { isMobile } from '../helpers/deviceUtils';
import { Pressable } from 'react-native-web';
import { useNavigate } from 'react-router-dom';
import AutoInsuranceTabs from './autoInsurance';

const isMobileDevice = isMobile();


function AutoHomePage({ navigation }) {
    const [zipCode, setZipCode] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [showInfo, setShowInfo] = useState(false);
    const styles = isMobileDevice ? mobileStyles : desktopStyles;
    const navigate = useNavigate()

    return (
        <View style={styles.root}>
            <View style={styles.header}>
                <View style={styles.headerContent}>
                    <Text style={styles.title}>{messages.title}</Text>
                </View>
            </View>

            <View style={styles.contentView}>
                <ImageBackground source={require('../assets/background.png')}
                    style={styles.image} />

                <View style={styles.mainContent} >
                    <Text style={styles.description}>{messages.description}</Text>
                    {errorMessage && <Text style={styles.error}>{errorMessage}</Text>}
                    <View style={styles.inputView}>
                        <TextInput style={styles.textInput}
                            placeholder={messages.zipCode}
                            placeholderTextColor={'rgba(25,28,31,0.5)'}
                            value={zipCode}
                            inputMode='numeric'
                            maxLength={5}
                            onChangeText={(newValue) => {
                                setZipCode(newValue);
                            }} />


                        <Pressable style={[styles.buttonView]}
                            onPress={() => {
                                const isValid = validator.isPostalCode(zipCode, "US");
                                if (isValid) {
                                    setErrorMessage("");
                                    setShowInfo(true);
                                } else {
                                    setErrorMessage(ERROR_MESSAGES.ZIP_CODE)
                                }
                            }}><ImageBackground source={require('../assets/button-background.png')}
                                style={styles.buttonImage} />
                            <View style={{ width: "80%", height: "100%", position: "absolute", alignItems: "center", justifyContent: "center" }}>
                                <Text style={[styles.buttonContent]}>{messages.seeQuotes}</Text>
                            </View>
                        </Pressable>
                    </View>
                </View>

                {showInfo && <AutoInsuranceTabs />}
            </View>
            <Footer navigation={navigation} style={styles.footer}>

            </Footer>

        </View>
    );
}

const baseStyles = StyleSheet.create(
    {
        root: {
            backgroundColor: '#91E9EC',
        },
        header: {
            height: window.innerHeight * 0.1,
            backgroundColor: 'white',
            justifyContent: "center"
        },
        title: {
            color: "#0B3C49",
            fontSize: 20,
            fontWeight: "800",
            fontFamily: 'Glegoo-Regular',
        },
        contentView: {
            height: window.innerHeight * 0.9,
            width: "100%",
        },
        image: {
            width: "100%",
            height: '100%',
            resizeMode: 'cover',
        },
        buttonImage: {
            width: "100%",
            height: '100%',
            resizeMode: 'contain',
            position: "absolute"
        },
        description: {
            color: "white",
            fontWeight: "700",
            fontFamily: 'Glegoo-Regular',
        },
        error: {
            color: "red",
            fontWeight: "400",
            lineHeight: 24,
            fontFamily: 'Glegoo-Regular',
        },
        inputView: {
            flexDirection: "row",
            marginTop: 40,
        },
        textInput: {
            backgroundColor: "white",
            borderRadius: 10,
            fontWeight: 400,
            fontFamily: 'Glegoo-Regular',
            padding: 15,
            marginVertical: 8
        },
        footer: {
            position: "absolute",
            marginTop: window.innerHeight * 0.94,
            flexDirection: "row",
            justifyContent: "center",
            width: "100%"
        },
        buttonView: {
            marginLeft: 20,
            position: "relative",
            alignItems: "flex-start",
            justifyContent: "center",
            width: 180,
            height: 80
        },
        buttonContent: {
            color: "#000000",
            fontSize: 16,
            lineHeight: "100%",
            fontWeight: "700",
            fontFamily: 'Glegoo-Regular',
            padding: 14
        },
    }
)

const desktopStyles = StyleSheet.create(
    {
        ...baseStyles,
        header: {
            ...baseStyles.header,
            width: '100%',
        },
        headerContent: {
            marginLeft: 215,
            flexDirection: "row"
        },
        title: {
            ...baseStyles.title,
            fontSize: 22,
        },
        contentView: {
            ...baseStyles.contentView,
            justifyContent: "center"
        },
        mainContent: {
            marginLeft: 215,
            maxWidth: 670,
            position: "absolute"
        },
        description: {
            ...baseStyles.description,
            fontSize: 64,
            lineHeight: 66
        },
        error: {
            ...baseStyles.error,
            fontSize: 24,
        },
        textInput: {
            ...baseStyles.textInput,
            fontSize: 12,
            width: 220
        },
    }
)


const mobileStyles = StyleSheet.create(
    {
        ...baseStyles,
        root: {
            ...baseStyles.root,
            height: "100%",
            width: '100%',
        },
        header: {
            ...baseStyles.header,
            width: window.innerWidth,
        },
        headerContent: {
            marginLeft: "10%",
            flexDirection: "row",
            alignItems: "center"
        },
        contentView: {
            ...baseStyles.contentView,
            justifyContent: "flex-start"
        },
        mainContent: {
            marginLeft: "10%",
            width: "80%",
            position: "absolute",
            marginTop: 65,
            paddingRight: 20
        },
        description: {
            ...baseStyles.description,
            fontSize: 30,
            lineHeight: 38
        },
        error: {
            ...baseStyles.error,
            fontSize: 20,
        },
        textInput: {
            ...baseStyles.textInput,
            fontSize: 10,
            width: "60%"
        },
    }
)

const messages = {
    title: "The Next Step Loan",
    description: "Move to the next step with a business loan with expert help",
    zipCode: "ENTER YOUR ZIP CODE",
    seeQuotes: "LET'S GO",
}

export default AutoHomePage;
